import React from 'react';
import PropTypes from 'prop-types';

const FastForwardPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M4.168 6.104A1.002 1.002 0 0 0 4 6.658v18.684a1 1 0 0 0 1.554.832l10.432-6.954v6.122a1 1 0 0 0 1.554.832l14.013-9.342a1 1 0 0 0 0-1.664L17.54 5.826a1 1 0 0 0-1.554.832v6.123L5.554 5.826a.998.998 0 0 0-1.386.278z"
    />
  );
};

FastForwardPath.propTypes = {
  fill: PropTypes.string,
};

export default FastForwardPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/fast-forward.jsx